import { FC } from 'react';
import { useClassNamesWithStyle } from '@edikk-edikk/country-frontend';
import { FavoriteToggle, MiddleButton, ContentControls } from '#baseMenu/components';
import menuControls from '../../assets/menu-controls.module.scss';

const Controls: FC = () => {
  const classNamesWithStyle = useClassNamesWithStyle();

  return (
    <div
      className={classNamesWithStyle(
        menuControls.menuControls,
        menuControls.menuControls_styleDefault,
        menuControls.menuControls_styleRed,
      )}
    >
      <FavoriteToggle />
      <MiddleButton />
      <ContentControls />
    </div>
  );
};

export { Controls };
